import {
  apiV2PowerRoomConfigCircuitDataPost,
  V2PowerRoomConfigCircuitDataPostResponse,
} from '@maxtropy/device-customer-apis-v2';
import { Button, EchartsWithTheme, Empty, Modal, Radio, useTheme } from '@maxtropy/components';
import React, { FC, useEffect, useMemo, useState } from 'react';
import { isNil } from 'lodash-es';
import { DataProperty, DataPropertyDisplay } from '../../utils';
import { getChartCurrentOption, getChartPowerOption, getChartVoltageOption } from './chart';
import { DoubleRightOutlined } from '@ant-design/icons';

interface CircuitDataModalProps {
  visible: boolean;
  onCancel: () => void;
  circuitId: number;
  circuitName: string;
}

const CircuitDataModal: FC<CircuitDataModalProps> = props => {
  const { visible, onCancel, circuitId, circuitName } = props;
  const [chartLoading, setChartLoading] = useState<boolean>(false);
  const [chartData, setChartData] = useState<V2PowerRoomConfigCircuitDataPostResponse>();
  const [currentProperty, setCurrentProperty] = useState<DataProperty>(DataProperty.Power);
  const theme = useTheme();

  useEffect(() => {
    if (!isNil(circuitId)) {
      setChartLoading(true);
      apiV2PowerRoomConfigCircuitDataPost({
        id: circuitId,
      })
        .then(res => {
          setChartData(res);
        })
        .finally(() => setChartLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [circuitId]);

  const option = useMemo(() => {
    if (currentProperty === DataProperty.Voltage) {
      return getChartVoltageOption(chartData);
    } else if (currentProperty === DataProperty.Current) {
      return getChartCurrentOption(chartData);
    } else {
      return getChartPowerOption(chartData);
    }
  }, [chartData, currentProperty]);

  return (
    <Modal
      open={visible}
      title={circuitName}
      size="big"
      destroyOnClose
      onCancel={onCancel}
      footer={<Button onClick={onCancel}>关闭</Button>}
    >
      <div style={{ display: 'flex' }}>
        <Radio.Group
          buttonStyle="solid"
          value={currentProperty}
          onChange={e => {
            setCurrentProperty(e.target.value);
          }}
        >
          <Radio.Button value={DataProperty.Power}>{DataPropertyDisplay[DataProperty.Power]}</Radio.Button>
          <Radio.Button value={DataProperty.Current}>{DataPropertyDisplay[DataProperty.Current]}</Radio.Button>
          <Radio.Button value={DataProperty.Voltage}>{DataPropertyDisplay[DataProperty.Voltage]}</Radio.Button>
        </Radio.Group>
        <Button
          type="link"
          onClick={() => {
            if (isNil(circuitId)) return;
            window.open(`${window.DMEPLATFORMSORIGIN}/dmes/statistics/circuit?id=${circuitId}`, '_blank');
          }}
        >
          前往回路数据
          <DoubleRightOutlined />
        </Button>
      </div>
      <div style={{ height: 480 }}>
        <EchartsWithTheme
          empty={{
            isShowEmpty: false,
            emptyNode: <Empty style={{ marginTop: 80 }} />,
          }}
          loading={chartLoading}
          option={option}
          style={{ height: 480, width: 960, marginTop: 24 }}
          theme={theme}
        />
      </div>
    </Modal>
  );
};

export default CircuitDataModal;
